import { tickerItems, flashes } from "@/mocks/home";

const statusStyle: Record<string, string> = {
  实锤: "bg-primary-100 text-primary-900 border-primary-200",
  发酵: "bg-accent-100 text-accent-900 border-accent-200",
  待核实: "bg-secondary-100 text-secondary-900 border-secondary-200",
};

const statusIcon: Record<string, string> = {
  实锤: "ri-check-double-line",
  发酵: "ri-fire-line",
  待核实: "ri-time-line",
};

export default function FlashSection() {
  return (
    <section id="flash" className="relative scroll-mt-20">
      {/* 跑马灯 strip */}
      <div className="border-y border-background-200/70 bg-background-100/60">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-3 flex items-center gap-4 overflow-hidden">
          <span className="shrink-0 inline-flex items-center gap-1.5 rounded-md bg-primary-500 text-background-50 px-2.5 py-1 text-xs font-bold whitespace-nowrap">
            <i className="ri-loop-left-line"></i> 滚动快讯
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="animate-ticker flex w-max gap-10 pr-10">
              {[...tickerItems, ...tickerItems].map((t, i) => (
                <span key={i} className="flex items-center gap-2 text-sm text-foreground-700 whitespace-nowrap">
                  <i className="ri-megaphone-line text-primary-500 text-xs"></i>
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* 时间线 */}
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 text-secondary-900 px-3 py-1 text-xs font-semibold">
              <i className="ri-signal-tower-line"></i> 吃瓜现场
            </span>
            <h2 className="mt-4 text-2xl md:text-4xl font-black text-foreground-950 tracking-tight">
              实时快讯流
            </h2>
            <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600">
              按分钟刷新，重大进展随时插队置顶。每条都带核验标签，别让旧消息耽误你吃最新的一口。
            </p>
          </div>
          <div className="flex items-center gap-2 text-sm text-foreground-500 shrink-0">
            <span className="relative flex h-2.5 w-2.5">
              <span className="absolute inline-flex h-full w-full rounded-full bg-primary-500 animate-ping"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-primary-500"></span>
            </span>
            今日已推送 128 条
          </div>
        </div>

        <div className="relative pl-5 md:pl-8">
          {/* vertical line */}
          <span className="absolute left-1.5 md:left-3 top-2 bottom-2 w-px bg-background-300"></span>

          <ol className="space-y-3">
            {flashes.map((f) => (
              <li key={f.time} className="relative">
                <span className="absolute -left-5 md:-left-8 top-5 w-3 h-3 rounded-full bg-background-50 border-2 border-primary-500"></span>
                <div className="group flex flex-col gap-1 rounded-lg border border-background-200/60 bg-background-50 px-4 py-3.5 hover:border-primary-300 hover:bg-primary-50/40 transition">
                  <div className="flex items-center gap-2.5 flex-wrap">
                    <span className="font-bold text-foreground-950 text-sm whitespace-nowrap">{f.time}</span>
                    <span className="rounded-md bg-background-100 text-foreground-600 px-2 py-0.5 text-xs whitespace-nowrap">{f.tag}</span>
                    <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-semibold ${statusStyle[f.status]}`}>
                      <i className={statusIcon[f.status]}></i> {f.status}
                    </span>
                    <span className="ml-auto inline-flex items-center gap-1 text-xs text-foreground-400 opacity-0 group-hover:opacity-100 transition whitespace-nowrap">
                      进入讨论 <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                  <p className="text-sm md:text-[15px] leading-relaxed text-foreground-700">{f.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>

        <div className="mt-8 flex justify-center">
          <button
            type="button"
            className="inline-flex items-center gap-2 rounded-md border border-background-300/70 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-800 hover:border-primary-300 hover:text-primary-700 transition whitespace-nowrap cursor-pointer"
          >
            查看更多历史快讯
            <i className="ri-arrow-down-s-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}